import React from 'react';
import { Router, Route } from 'react-router';
import StartScreen from './components/Screens/StartScreen.js';
import QuestionsScreen from './components/Screens/QuestionsScreen.js';
import PaymentScreen from './components/Screens/PaymentScreen.js';
import PaymentSuccess from './components/Screens/Payment/PaymentSuccess.js';
import PaymentFailed from './components/Screens/Payment/PaymentFailed.js';
import InceptionLoad from './components/Screens/Payment/InceptionLoad.js';
import QuoteSummaryScreen from './components/Screens/QuoteSummaryScreen.js';
import QuoteLoadScreen from './components/Screens/QuoteLoadScreen.js';
import FailedLoadingScreen from './components/Screens/Quote/FailedLoading';

import QuoteErrorRecoverable from './components/Screens/Quote/ErrorRecoverable.js';
import QuotePreReferral from './components/Screens/Quote/PreReferral.js';
import QuoteReferred from './components/Screens/Quote/QuoteReferred.js';

import ApplicationError from './components/Screens/ApplicationError.js';
import NotFound from './components/Screens/NotFound.js';

export default (
    <Router>
        <Route path="/" component={StartScreen} />
        <Route path="/start" component={StartScreen} />

        <Route path="/asn/:asn" component={StartScreen} />

        <Route path="/questions" component={QuestionsScreen} />

        <Route path="/quote" component={QuoteSummaryScreen} />
        <Route path="/quote-retrieval" component={QuoteLoadScreen} />
        <Route path="/quote-retrieval/:quoteId" component={QuoteLoadScreen} />
        <Route path="/load-quote-failed" component={FailedLoadingScreen} />

        <Route path="/payment" component={PaymentScreen} />
        <Route path="/success" component={PaymentSuccess} />
        <Route path="/payment-error" component={PaymentFailed} />
        <Route path="/inception" component={InceptionLoad} />

        <Route path="/pre-referral" component={QuotePreReferral} />
        <Route path="/quote-recoverable-issue" component={QuoteErrorRecoverable} />
        <Route path="/quote-referred" component={QuoteReferred} />

        <Route path="/error(/:errorid)" component={ApplicationError} />
        // This NotFound route needs to be at the bottom of this route list as it is
        // against all routes '*' and is only used if no other route above is selected
        <Route path="*" component={NotFound} />
    </Router>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/